// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../dist/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../dist/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_containerWrapper__1oLCi{
    display:flex;
    justify-content: flex-start;
    /* flex-direction:column; */
    align-items:center;
    flex-wrap:wrap;
    width:40vw;
    height:auto;
    padding:10px;


}.styles_containerWrapper__1oLCi svg{
  cursor:pointer;
}
.styles_container__ebwr8{
    display:flex;
    justify-content: flex-start;
    flex-direction:column;
    align-items:flex-start;
    /* flex-wrap:wrap; */
    width:100%;
    height:auto;
    padding:10px;
    max-height:90vh;
    min-height:70vh;
    overflow:auto;

    scrollbar-color: #e3e3e3 transparent;
    scrollbar-width: 8px;
  }
  .styles_container__ebwr8::-webkit-scrollbar {
  
    background: transparent;
    width: 8px;
  }
  .styles_userText__g2skA{
    margin:0 5px;
  }
  .styles_container__ebwr8::-webkit-scrollbar-thumb {
    background-color: #e3e3e3;
    border-radius: 100px;
    height: 8px;
  }
.styles_container__ebwr8>div{
    width:100%;
    padding:10px;
    margin-bottom:20px;
}


.styles_settingBox__QlNdT{
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  position: absolute;
  top: 68%;
  left: 19px !important;
  position: absolute;
  z-index: 1000;
  padding: 10px;
  top: 90%;
  right: unset !important;
  font-size: 12px !important;
}
.styles_moreBoxRight__0sNhq{
  right:0 !important;
  left:unset !important;

}
.styles_settingBoxRight__601gi{
  right:0px !important;
  left:unset !important;
}

@media only screen and (max-width: 650px) {
  .styles_containerWrapper__1oLCi{
    width:80vw;
  }
}`, "",{"version":3,"sources":["webpack://./../src/renderer/components/GroupMembers/styles.module.css"],"names":[],"mappings":"AAAA;IACI,YAAY;IACZ,2BAA2B;IAC3B,2BAA2B;IAC3B,kBAAkB;IAClB,cAAc;IACd,UAAU;IACV,WAAW;IACX,YAAY;;;AAGhB,CAAC;EACC,cAAc;AAChB;AACA;IACI,YAAY;IACZ,2BAA2B;IAC3B,qBAAqB;IACrB,sBAAsB;IACtB,oBAAoB;IACpB,UAAU;IACV,WAAW;IACX,YAAY;IACZ,eAAe;IACf,eAAe;IACf,aAAa;;IAEb,oCAAoC;IACpC,oBAAoB;EACtB;EACA;;IAEE,uBAAuB;IACvB,UAAU;EACZ;EACA;IACE,YAAY;EACd;EACA;IACE,yBAAyB;IACzB,oBAAoB;IACpB,WAAW;EACb;AACF;IACI,UAAU;IACV,YAAY;IACZ,kBAAkB;AACtB;;;AAGA;EACE,aAAa;EACb,sBAAsB;EACtB,2BAA2B;EAC3B,uBAAuB;EACvB,kBAAkB;EAClB,QAAQ;EACR,qBAAqB;EACrB,kBAAkB;EAClB,aAAa;EACb,aAAa;EACb,QAAQ;EACR,uBAAuB;EACvB,0BAA0B;AAC5B;AACA;EACE,kBAAkB;EAClB,qBAAqB;;AAEvB;AACA;EACE,oBAAoB;EACpB,qBAAqB;AACvB;;AAEA;EACE;IACE,UAAU;EACZ;AACF","sourcesContent":[".containerWrapper{\n    display:flex;\n    justify-content: flex-start;\n    /* flex-direction:column; */\n    align-items:center;\n    flex-wrap:wrap;\n    width:40vw;\n    height:auto;\n    padding:10px;\n\n\n}.containerWrapper svg{\n  cursor:pointer;\n}\n.container{\n    display:flex;\n    justify-content: flex-start;\n    flex-direction:column;\n    align-items:flex-start;\n    /* flex-wrap:wrap; */\n    width:100%;\n    height:auto;\n    padding:10px;\n    max-height:90vh;\n    min-height:70vh;\n    overflow:auto;\n\n    scrollbar-color: #e3e3e3 transparent;\n    scrollbar-width: 8px;\n  }\n  .container::-webkit-scrollbar {\n  \n    background: transparent;\n    width: 8px;\n  }\n  .userText{\n    margin:0 5px;\n  }\n  .container::-webkit-scrollbar-thumb {\n    background-color: #e3e3e3;\n    border-radius: 100px;\n    height: 8px;\n  }\n.container>div{\n    width:100%;\n    padding:10px;\n    margin-bottom:20px;\n}\n\n\n.settingBox{\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start;\n  align-items: flex-start;\n  position: absolute;\n  top: 68%;\n  left: 19px !important;\n  position: absolute;\n  z-index: 1000;\n  padding: 10px;\n  top: 90%;\n  right: unset !important;\n  font-size: 12px !important;\n}\n.moreBoxRight{\n  right:0 !important;\n  left:unset !important;\n\n}\n.settingBoxRight{\n  right:0px !important;\n  left:unset !important;\n}\n\n@media only screen and (max-width: 650px) {\n  .containerWrapper{\n    width:80vw;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"containerWrapper": `styles_containerWrapper__1oLCi`,
	"container": `styles_container__ebwr8`,
	"userText": `styles_userText__g2skA`,
	"settingBox": `styles_settingBox__QlNdT`,
	"moreBoxRight": `styles_moreBoxRight__0sNhq`,
	"settingBoxRight": `styles_settingBoxRight__601gi`
};
export default ___CSS_LOADER_EXPORT___;
